// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthBox_container__3QWEt"};